(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // Rotation automatique des messages de la top-bar
  (function() {
    const topBar = document.querySelector('[data-top-bar]');
    const messagesContainer = document.querySelector('[data-messages-container]');
    
    if (!topBar || !messagesContainer) return;
    
    const messages = messagesContainer.querySelectorAll('[data-message-index]');
    if (messages.length <= 1) return; // Pas besoin de rotation s'il n'y a qu'un seul message
    
    let currentIndex = 0;
    let rotationInterval = null;
    const MESSAGE_DURATION = 10000; // 10 secondes
    
    function showMessage(index) {
      // Retirer la classe active de tous les messages
      messages.forEach(msg => {
        msg.classList.remove('is-active');
      });
      
      // Ajouter la classe active au message courant
      if (messages[index]) {
        messages[index].classList.add('is-active');
      }
    }
    
    function nextMessage() {
      currentIndex = (currentIndex + 1) % messages.length;
      showMessage(currentIndex);
    }
    
    function startRotation() {
      if (rotationInterval) {
        clearInterval(rotationInterval);
      }
      rotationInterval = setInterval(nextMessage, MESSAGE_DURATION);
    }
    
    function stopRotation() {
      if (rotationInterval) {
        clearInterval(rotationInterval);
        rotationInterval = null;
      }
    }
    
    // Initialiser avec le premier message
    showMessage(0);
    
    // Démarrer la rotation automatique
    startRotation();
    
    // Gérer la visibilité de la page
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopRotation();
      } else {
        startRotation();
      }
    });
  })();

  // Ajuster dynamiquement la position du header en fonction de la hauteur de la barre
  document.addEventListener('DOMContentLoaded', function() {
    const topBar = document.querySelector('.top-bar');
    const header = document.querySelector('.site-header');
    
    if (topBar && header) {
      function updateHeaderPosition() {
        const topBarHeight = topBar.offsetHeight;
        document.documentElement.style.setProperty('--top-bar-height', topBarHeight + 'px');
        header.style.top = topBarHeight + 'px';
      }
      
      updateHeaderPosition();
      
      // Réajuster en cas de redimensionnement
      window.addEventListener('resize', updateHeaderPosition);
      
      // Observer les changements de contenu de la barre
      const observer = new MutationObserver(updateHeaderPosition);
      observer.observe(topBar, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-minimal"] && !Shopify.designMode) return;
  try {
    
  // Transform ||| separator into styled highlight effect
  (function() {
    function processHeroTitles() {
      const heroTitles = document.querySelectorAll('[data-hero-title]');
      
      heroTitles.forEach(function(title) {
        // Skip if already processed
        if (title.dataset.processed === 'true') return;
        
        // Get the HTML content
        let html = title.innerHTML;
        
        // Check if there's a ||| separator
        if (html.includes('|||')) {
          // Split by ||| separator
          const parts = html.split('|||');
          
          if (parts.length > 1) {
            // First part stays as is
            let newHtml = parts[0];
            
            // Wrap the rest in a span with special styling
            for (let i = 1; i < parts.length; i++) {
              const trimmed = parts[i].trim();
              if (trimmed) {
                newHtml += '<span class="hero__title-line-2">' + trimmed + '</span>';
              }
            }
            
            title.innerHTML = newHtml;
            title.dataset.processed = 'true';
          }
        }
      });
    }
    
    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processHeroTitles);
    } else {
      processHeroTitles();
    }
    
    // Also run after a short delay to catch dynamically loaded content
    setTimeout(processHeroTitles, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const root = document.currentScript.closest('.ingredients');
    const scroller = root.querySelector('[data-ingredients-scroller] .ingredients__list');
    const prev = root.querySelector('[data-scroll-prev]');
    const next = root.querySelector('[data-scroll-next]');
    const prevOverlay = root.querySelector('[data-scroll-prev-overlay]');
    const nextOverlay = root.querySelector('[data-scroll-next-overlay]');
    const dotsContainer = root.querySelector('[data-dots]');
    if(!scroller) return;
    const items = Array.from(scroller.children);
    const step = () => scroller.clientWidth * 0.8;
    const goPrev = ()=> scroller.scrollBy({ left: -step(), behavior: 'smooth' });
    const goNext = ()=> scroller.scrollBy({ left: step(), behavior: 'smooth' });
    prev?.addEventListener('click', goPrev);
    next?.addEventListener('click', goNext);
    prevOverlay?.addEventListener('click', goPrev);
    nextOverlay?.addEventListener('click', goNext);

    // Dots pagination for mobile
    if(dotsContainer){
      dotsContainer.innerHTML = items.map((_, i)=> `<button type="button" aria-label="Aller à l’élément ${i+1}" aria-current="${i===0}"></button>`).join('');
      const dots = Array.from(dotsContainer.querySelectorAll('button'));
      const update = () => {
        // compute the index based on scrollLeft and item width
        const itemWidth = items[0]?.getBoundingClientRect().width || 1;
        const gap = parseFloat(getComputedStyle(scroller).columnGap || 16) || 16;
        const index = Math.round(scroller.scrollLeft / (itemWidth + gap));
        dots.forEach((d, i)=> d.setAttribute('aria-current', String(i===index)) );
        items.forEach((li, i)=> li.classList.toggle('is-active', i===index));
      };
      scroller.addEventListener('scroll', () => { window.requestAnimationFrame(update); }, { passive: true });
      dots.forEach((d, i)=> d.addEventListener('click', ()=> scroller.scrollTo({ left: i * (items[0].offsetWidth + (parseFloat(getComputedStyle(scroller).columnGap || 16) || 16)), behavior: 'smooth' })) );
      update();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Toggle pour toute la section des ingrédients
    document.addEventListener('click', function(e) {
      const sectionToggle = e.target.closest('.ingredients-section-toggle');
      if (sectionToggle) {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = sectionToggle.getAttribute('aria-expanded') === 'true';
        const contentId = sectionToggle.getAttribute('aria-controls');
        const content = document.getElementById(contentId);
        
        if (!content) return;
        
        const newState = !isExpanded;
        sectionToggle.setAttribute('aria-expanded', String(newState));
        content.setAttribute('aria-hidden', String(!newState));
        
        // Mettre à jour le texte du bouton
        const toggleText = sectionToggle.querySelector('.ingredients-toggle-text');
        if (toggleText) {
          const textOpen = sectionToggle.getAttribute('data-toggle-text-open') || '';
          const textClose = sectionToggle.getAttribute('data-toggle-text-close') || '';
          toggleText.textContent = newState ? textClose : textOpen;
        }
        
        return;
      }
      
      // Toggle pour chaque ingrédient individuel
      const toggle = e.target.closest('.ingredient-toggle');
      if (!toggle) return;
      
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const contentId = toggle.getAttribute('aria-controls');
      const content = document.getElementById(contentId);
      const item = toggle.closest('.ingredient-item');
      
      if (!content || !item) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      // Toggle state
      const newState = !isExpanded;
      toggle.setAttribute('aria-expanded', String(newState));
      content.setAttribute('aria-hidden', String(!newState));
      
      // Update data attribute for CSS
      if (newState) {
        item.setAttribute('data-expanded', 'true');
      } else {
        item.removeAttribute('data-expanded');
      }
    }, true); // Utiliser capture phase pour être sûr
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-page"] && !Shopify.designMode) return;
  try {
    
  // Calculer dynamiquement la hauteur totale du header (top-bar + header)
  document.addEventListener('DOMContentLoaded', function() {
    const legalPage = document.querySelector('.legal-page');
    const topBar = document.querySelector('.top-bar');
    const header = document.querySelector('.site-header');
    
    if (legalPage && topBar && header) {
      function updatePaddingTop() {
        const topBarHeight = topBar.offsetHeight;
        const headerHeight = header.offsetHeight;
        const totalHeight = topBarHeight + headerHeight;
        legalPage.style.paddingTop = totalHeight + 'px';
      }
      
      updatePaddingTop();
      
      // Réajuster en cas de redimensionnement
      window.addEventListener('resize', updatePaddingTop);
      
      // Observer les changements de taille de la top-bar et du header
      const resizeObserver = new ResizeObserver(updatePaddingTop);
      resizeObserver.observe(topBar);
      resizeObserver.observe(header);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-overview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root){
      const form = root.querySelector('#product-form-overview');
      const input = form && form.querySelector('[data-variant-input]');
      const buttons = root.querySelectorAll('.variant-btn');
      const main = root.querySelector('[data-gallery-main]');
      const slides = main ? main.querySelectorAll('.gallery-slide') : [];
      const thumbsContainer = root.querySelector('[data-gallery-thumbs]');

      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.getAttribute('data-variant-id');
          if (input) input.value = id;
          buttons.forEach(b => b.setAttribute('aria-pressed', 'false'));
          btn.setAttribute('aria-pressed', 'true');
        });
      });

      function activateByIndex(idx){
        const i = Math.max(0, Math.min(slides.length - 1, Number(idx) || 0));
        slides.forEach(s => s.classList.remove('is-active'));
        root.querySelectorAll('.thumb').forEach(t => t.classList.remove('is-active'));
        const target = slides[i];
        if (target) target.classList.add('is-active');
        const th = root.querySelector('.thumb[data-go-to="' + i + '"]');
        th && th.classList.add('is-active');
      }

      if (thumbsContainer){
        thumbsContainer.addEventListener('click', (e) => {
          const btn = e.target.closest('.thumb');
          if(!btn) return;
          e.preventDefault();
          activateByIndex(btn.getAttribute('data-go-to'));
        });
      }
    }

    // init on load
    document.querySelectorAll('.section-product-overview').forEach(init);
    // re-init when the section is reloaded in Shopify editor
    document.addEventListener('shopify:section:load', (ev) => {
      if (ev.target && ev.target.classList.contains('section-product-overview')) init(ev.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
